import axios from 'axios';

const { CancelToken } = axios;
let wjCancel;

const errorRequest = (error) => {
  let err = { _error: 'Server Error. Please try again later' };
  if (error.response && error.response.data) {
    err = {
      ...error.response.data.errors,
      _error: error.response.data.error,
    };
  }
  return err;
};

function getEventPublic(slug, callback, reload = false) {
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'CHECK_EVENT_FOR_BUCKET', slug });
    if (!getState().eventsBucket.activeEvent.slug || reload) {
      dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
      return api({
        method: 'GET',
        url: `/eventpublic`,
        // todo refactor back
        params: { slugs: slug },
      }).then(
        (data) => {
          const { events } = data.data;
          // todo refact back
          let event = events[0];
          if (!event) {
            event = {};
          }
          dispatch({ type: 'GET_EVENT_PUBLIC', event });
          callback && callback(null);
        },
        (error) => {
          const err = errorRequest(error);
          dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
          callback && callback(err);
        },
      );
    }
    return callback ? callback(null) : '';
  };
}

const getEventByEdit =
  (slug, callback = null) =>
  (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
    return api({
      method: 'GET',
      url: `/event/getEventByEdit`,
      params: { slug },
    }).then(
      (returnedData) => {
        const { event } = returnedData.data;
        dispatch({ type: 'GET_EVENT_EDIT', event });
        if (callback) {
          callback();
        }
      },
      (error) => {
        const err = errorRequest(error);
        dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
      },
    );
  };

const createUpdateEvent =
  (data, callback) =>
  (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
    return api({
      method: 'PUT',
      url: `/event`,
      data,
    }).then(
      (returnedData) => {
        const { event } = returnedData.data;
        dispatch({ type: 'GET_EVENT_PUBLIC', event });
        callback(null, event);
      },
      (error) => {
        const err = errorRequest(error);
        dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
        callback(err, null);
      },
    );
  };

function editActiveEvent(body, callback) {
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
    return api({
      method: 'POST',
      url: `/event/${body.slug}`,
      data: body,
    }).then(
      (data) => {
        const { event } = data.data;
        dispatch({ type: 'GET_EVENT_PUBLIC', event });
        callback(null, event);
      },
      (error) => {
        const err = errorRequest(error);
        dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
        callback(err);
      },
    );
  };
}

function duplicateEvent(slug, params, callback) {
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_REQUESTED' });
    return api({
      method: 'PUT',
      url: `/event/${slug}`,
      data: params,
    }).then(
      (data) => {
        const { event, user } = data.data;
        callback(null, event.slug);
        dispatch({ type: 'GET_EVENT_PUBLIC', event });
        dispatch({ type: 'ADD_ONE_EVENT_BUCKET', event, user });
      },
      (error) => {
        const err = errorRequest(error);
        callback(err);
        dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
      },
    );
  };
}

function deleteActiveEvent(slug, callback) {
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
    return api({
      method: 'DELETE',
      url: `/event/`,
      params: { slug },
    }).then(
      (data) => {
        let event = null;
        if (data.data.event) {
          event = data.data.event;
        }
        dispatch({ type: 'DELETE_ACTIVE_EVENT', slug, event });
        callback();
      },
      (error) => {
        const err = errorRequest(error);
        callback(err._error);
        dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
      },
    );
  };
}

function pushActiveEvent(params, callback) {
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
    return api({
      method: 'POST',
      url: `/event/pushEven`,
      params,
    }).then(
      (data) => {
        const { event } = data.data;
        const { message } = data.data;
        dispatch({ type: 'GET_EVENT_PUBLIC', message, event });
        callback(null, event);
      },
      (error) => {
        const err = errorRequest(error);
        dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
        callback && callback(err);
      },
    );
  };
}

function pushActiveEventRefactor(params, data, callback) {
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
    return api({
      method: 'POST',
      url: `/Moderator/${params.slugEvent}`,
      params: {
        slugEvent: params,
      },
      data: {
        refactorText: data,
      },
    }).then(
      (data2) => {
        const { event } = data2.data;
        const { message } = data2.data;
        dispatch({ type: 'GET_EVENT_PUBLIC', message, event });
        callback(null, event);
      },
      (error) => {
        const err = errorRequest(error);
        dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
        callback && callback(err);
      },
    );
  };
}

function getEventsHomePage(params, callback = () => {}) {
  const { eventBlock, perpage } = params;
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_BUCKET_GET_OBGECT', eventBlock });
    dispatch({ type: 'EVENTS_BUCKET_CHECK_PUBLIC', eventBlock, perpage });
    const slugEvent = getState().eventsBucket.redaxEventBucket[eventBlock];
    if (!slugEvent || !slugEvent.slug || slugEvent.slug.length === 0) {
      dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
      return api({
        method: 'GET',
        url: '/search/events',
        params,
      }).then(
        (data) => {
          if (!data.data.isNoResults) {
            const { events, total, header } = data.data;
            dispatch({
              type: 'PUSH_EVENT_REDAX_BUCKET',
              eventBlock,
              events,
              total,
              header,
            });
            callback(null, true);
          } else {
            dispatch({ type: 'EVENTS_BUCKET_REQUEST_END' });
            callback(null, null);
          }
        },
        (error) => {
          const err = errorRequest(error);
          dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
          callback(err, null);
        },
      );
    }
    return callback(null, null);
  };
}
function getEventArchive(params) {
  const { eventBlock } = params;
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_NULL' });
    dispatch({ type: 'EVENTS_BUCKET_GET_OBGECT', eventBlock });
    // const slugEvent = getState().eventsBucket.redaxEventBucket[eventBlock];
    // if (!slugEvent || !slugEvent.slug || slugEvent.slug.length === 0) {
    dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
    return api({
      method: 'GET',
      url: `/eventPublic/archive`,
      params,
    }).then(
      (data) => {
        const { events, total, header } = data.data;
        dispatch({
          type: 'PUSH_EVENT_REDAX_BUCKET',
          eventBlock,
          events,
          total,
          header,
        });
      },
      (error) => {
        const err = errorRequest(error);
        dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
      },
    );
    // }
  };
}
function gerFleet(params) {
  const { eventBlock } = params;
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_NULL' });
    dispatch({ type: 'EVENTS_BUCKET_GET_OBGECT', eventBlock });
    // const slugEvent = getState().eventsBucket.redaxEventBucket[eventBlock];
    // if (!slugEvent || !slugEvent.slug || slugEvent.slug.length === 0) {
    dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
    return api({
      method: 'GET',
      url: `/boatPublic/getFleet`,
      params,
    }).then(
      (data) => {
        const { events, total, header } = data.data;
        dispatch({
          type: 'PUSH_EVENT_REDAX_BUCKET',
          eventBlock,
          events,
          total,
          header,
        });
      },
      (error) => {
        const err = errorRequest(error);
        dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
      },
    );
    // }
  };
}

function getEventByStatus(params, callback) {
  const { eventBlock } = params;
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_NULL' });
    dispatch({ type: 'EVENTS_BUCKET_GET_OBGECT', eventBlock });
    const slugEvent = getState().eventsBucket.redaxEventBucket[eventBlock];

    if (!slugEvent || !slugEvent.slug || slugEvent.slug.length === 0) {
      dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
      return api({
        method: 'GET',
        url: `/event/getEventByStatus`,
        params,
      }).then(
        (data) => {
          const { events, total, header } = data.data;
          dispatch({
            type: 'PUSH_EVENT_REDAX_BUCKET',
            eventBlock,
            events,
            total,
            header,
          });
          callback && callback(null, events);
        },
        (error) => {
          const err = errorRequest(error);
          dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
          callback && callback(err);
        },
      );
    }
  };
}

function getTicketsByStatus(params) {
  const { eventBlock } = params;
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_NULL' });
    dispatch({ type: 'EVENTS_BUCKET_GET_OBGECT', eventBlock });
    const slugEvent = getState().eventsBucket.redaxEventBucket[eventBlock];

    if (!slugEvent || !slugEvent.slug || slugEvent.slug.length === 0) {
      dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
      return api({
        method: 'GET',
        url: `/ticket/tickets`,
        params,
      }).then(
        (data) => {
          const events = data.data.publicEvents;
          const total = events ? events.length : 0;
          dispatch({
            type: 'PUSH_EVENT_REDAX_BUCKET',
            eventBlock,
            events,
            total,
            header: data.data.header,
          });
        },
        (error) => {
          const err = errorRequest(error);
          dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
        },
      );
    }
  };
}

function moveTicket(params, data, callback) {
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
    return api({
      method: 'POST',
      url: `/ticket/moveTicket`,
      params,
      data,
    }).then(
      (res) => {
        const { event } = res.data;
        dispatch({ type: 'GET_EVENT_PUBLIC', event });
        callback(null, event);
      },
      (error) => {
        const err = errorRequest(error);
        dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
        callback(err);
      },
    );
  };
}

function getResultEvents(data, callback, params) {
  // todo check store
  return (dispatch, getState, { api }) => {
    const hash = JSON.stringify(data);
    const hashRequest = JSON.stringify(data);
    if (getState().events.tmpLastRequestedHash === hash) {
      return null;
    }

    dispatch({ type: 'EVENTS_BUCKET_REQUESTED' });
    return api({
      method: 'GET',
      url: `/search/events`,
      params: data,
    }).then(
      (req) => {
        const { total, events, header } = req.data;
        let category = [];
        let country = [];
        let startedDates = [];
        let simplifeid = [];

        if (req.data.filters) {
          category = req.data.filters.category;
          country = data.data.filters.start_location_country_code;
          startedDates = data.data.filters.started_dates;
        }
        if (req.data.simpleEvents) {
          simplifeid = data.data.simpleEvents.items;
        }
        params && params(category, country);
        dispatch({
          type: 'GET_EVENTS_FOR_RESULT',
          total,
          simplifeid,
          events,
          hashRequest,
          header,
        });

        dispatch({ type: 'CATEGORY_SUCCESS', category });
        dispatch({ type: 'COUNTRY_SUCCESS', country });
        dispatch({ type: 'STARTED_DATES_SUCCESS', startedDates });

        if (data.data.isNoResults) {
          dispatch({ type: 'GET_EVENTS_FOR_RESULT_ON_CHANGE', value: '' });
        }
        callback && callback(null, events);
      },
      (error) => {
        let err = { _error: 'Server Error. Please try again later' };
        if (error.response && error.response.data) {
          err = {
            ...error.response.data.errors,
            _error: error.response.data.error,
          };
        }
        dispatch({ type: 'EVENTS_BUCKET_REQUEST_FAILURE', errors: err });
        callback && callback(err);
      },
    );
  };
}

function onChange(value) {
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'EVENTS_ON_CHANGE', value });
    const data = {
      perpage: 4,
      q: value,
    };
    if (value.length < 3) {
      const eventIssuing = [];
      dispatch({ type: 'SEARCH_FEATCH_SUCCESS', eventIssuing });
    }
    if (value.length > 2) {
      wjCancel && wjCancel();
      dispatch({ type: 'SEARCH_REQUESTED' });
      return api({
        method: 'GET',
        url: `/search/events`,
        params: data,
        cancelToken: new CancelToken((c) => {
          wjCancel = c;
        }),
      }).then(
        (data) => {
          let eventIssuing = data.data.events;

          if (data.data.isNoResults) {
            eventIssuing = [];
            // dispatch({ type: 'EVENTS_ON_CHANGE', value: '' });
            dispatch({ type: 'SEARCH_FEATCH_SUCCESS', eventIssuing });
          } else {
            dispatch({ type: 'SEARCH_FEATCH_SUCCESS', eventIssuing });
            dispatch({ type: 'SEARCH_REQUEST_FAILURE' });
          }
          // callback && callback(null, events);
        },
        () => {
          dispatch({ type: 'SEARCH_REQUEST_FAILURE' });
        },
      );
    }
  };
}

export default {
  createUpdateEvent,
  getEventPublic,
  getEventByEdit,
  editActiveEvent,
  deleteActiveEvent,
  pushActiveEvent,
  pushActiveEventRefactor,
  getEventsHomePage,
  getResultEvents,
  getEventByStatus,
  duplicateEvent,
  getTicketsByStatus,
  moveTicket,
  onChange,
  getEventArchive,
  gerFleet,
};
